// import React, { useEffect } from "react";
// import { X } from "lucide-react";

// const LargeModal = ({ isOpen, onClose, title, content , onCloseExtra  }) => {
//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.key === "Escape") {
//         onClose();
//       }
//     };
//     document.addEventListener("keydown", handleKeyDown);
//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [onClose]);

//   if (!isOpen) return null;


//   const handleClose = () => {
//   if (onCloseExtra) {
//     onCloseExtra(); 
//   }
//   onClose(); 
// };

//   return (
//     <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      
//       {/* Full Screen Modal */}
//       <div className="w-full h-full bg-white flex flex-col">
        
//         {/* Header */}
//         <div className="sticky top-0 z-10 flex items-center justify-between px-3 py-2 border-b bg-white shadow-sm">
//           <h2 className="text-lg md:text-xl font-semibold text-gray-800">
//             {title}
//           </h2>

//           <button
//             // onClick={onClose}
//             onClick={handleClose}
//             className="p-2 rounded-full hover:bg-gray-100 transition"
//           >
//             <X className="w-5 h-5 text-red-700" />
//           </button>
//         </div>

//         {/* Content */}
//         <div className="flex-1 overflow-y-auto px-2">
//           {content}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default LargeModal;

import React, { useEffect } from "react";
import { X } from "lucide-react";

const LargeModal = ({ isOpen, onClose, title, content }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center top-16">
      
      {/* Full Screen Modal */}
      <div className="w-full h-full bg-white flex flex-col">
        
        {/* Header */}
        <div className="sticky top-0 z-10 flex items-center justify-between px-3 py-2 border-b bg-white shadow-sm">
          <h2 className="text-lg md:text-xl font-semibold text-gray-800">
            {title}
          </h2>

          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 transition"
          >
            <X className="w-5 h-5 text-red-700" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-2">
          {content}
        </div>

      </div>
    </div>
  );
};

export default LargeModal;